module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/01_shape-lg-8dade928b712d6580fc18fc411a1c4c1.png";